import React, { Component } from 'react'
import { embedded } from '@services/api'
import { inject, observer } from 'mobx-react'
import helper from '../helper'
import { Button, Row, Icon } from 'antd'
import UploadFilePopup from '@components/Popup/UploadFilePopup'

@inject((store: any) => {
    const { authStore, popupStore } = store
    return { authStore, popupStore }
})
@observer
export default class extends Component {
    constructor(props) {
        super(props)
        this.state = { value: helper[props.name].get ? helper[props.name].get(props.con.link) : '' }
    }

    render() {
        const {
            con,
            name,
            authStore: { fullName },
            popupStore
        } = this.props
        const { value } = this.state
        let marginRight = { marginRight: 12 }
        let { rule, isLocalSaveNeeded } = helper[name]
        let link = rule ? rule.replace('$d$', value) : ''

        return (
            <Row gutter={28}>
                {rule ? (
                    <>
                        <span dir="ltr">
                            {rule.slice(0, rule.indexOf('$d$'))}
                            <input
                                value={value}
                                style={{ width: (value.length + 1) * 9 }}
                                onChange={e => this.setState({ value: e.target.value })}
                            />
                            {rule.slice(rule.indexOf('$d$') + 3)}
                        </span>
                        <a href={link} target="_blank" rel="noopener noreferrer">
                            <Button icon="eye" style={marginRight} />
                        </a>
                    </>
                ) : (
                    ''
                )}
                {isLocalSaveNeeded ? (
                    <Button
                        style={marginRight}
                        onClick={() =>
                            popupStore.togglePopup('uploadFile', {
                                bucket: 'media',
                                related: con.id,
                                types: ['embedded'],
                                uniq: true
                            })
                        }
                    >
                        <Icon type="upload" />
                    </Button>
                ) : (
                    ''
                )}
                {rule ? (
                    <Button
                        icon="check"
                        style={marginRight}
                        onClick={() =>
                            embedded
                                .updateLink({ id: con.id, link, updated_by: fullName })
                                .then(() => alert('ערך שונה בהצלחה, כל הכבוד! :)'))
                                .catch(err => {
                                    alert(' בעיית שרת, ערך לא שונה')
                                })
                        }
                    />
                ) : (
                    ''
                )}
                <UploadFilePopup />
            </Row>
        )
    }
}
